import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: ${tokens.space.large};
`;

export const SubTitle = styled.div`
  font-family: ${tokens.fonts.primary};
  font-size: ${tokens.fontSizes.xl};
  line-height: 42px;
  display: flex;
  align-items: center;
  text-align: center;
  color: ${tokens.colors.grayDarkest};
  max-width: 720px;

  ${tokens.mediaQueries.s} {
    padding: 0 ${tokens.space.small};
    line-height: ${tokens.lineHeights.m};
    font-size: ${tokens.fontSizes.m};
    margin-bottom: ${tokens.space.larger};
  }
`;

export const Items = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1125px;
  margin-bottom: ${tokens.space.loose};

  ${tokens.mediaQueries.s} {
    flex-direction: column;
    align-items: center;
  }
`;
